import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { FONTS } from "../../../constants";
import { addAlpha } from "../../../helpers/DataHelpers";
import Column from "../../../MachineLearning/Column";
import {
  getBarColors,
  getBarColorsSame,
} from "../../VariableCorrelations/DualChart";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chartContainer: {
      width: "90%",
      height: "60%",
      marginLeft: "5%",
    },
    chartContainer2: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      position: "relative",
    },
    legendContainer: {
      display: "flex",
      flexDirection: "row",
      marginTop: "30px",
      marginLeft: "20px",
      width: "100%",
      justifyContent: "center",
      marginBottom: "0px",
      zIndex: 100,
    },
    legendItemContainer: {
      display: "flex",
      flexDirection: "row",
      zIndex: 100,
    },
    ellipse: {
      fontSize: "15px",
      fontFamily: FONTS,
      marginLeft: "15px",
      marginRight: "-15px",
      lineHeight: "22px",
      fontWeight: "bold",
      color: "rgba(0,0,0,0.6)",
      width: "50px",
      zIndex: 1000,
    },
    sliderContainer: {
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
    },
    titleCorContainer: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "spaceBetween",
      marginBottom: "10px",
      marginTop: "5px",
    },
  })
);

type legendType = {
  yCol: Column;
  legendNames?: string[];
  visible?: boolean;
  colors?: string[];
  isSame?: boolean;
};
type legendItemType = { color: string; name: string };

function LegendItem({ color, name }: legendItemType) {
  const classes = useStyles();
  return (
    <div className={classes.legendItemContainer}>
      <div
        style={{
          width: "20px",
          height: "20px",
          backgroundColor: color,
          marginLeft: "10px",
        }}
      ></div>
      <div
        style={{
          lineHeight: "20px",
          fontSize: "12px",
          marginLeft: "5px",
          fontFamily: FONTS,
          color: "rgba(0,0,0,0.8)",
        }}
      >
        {name}
      </div>
    </div>
  );
}

export function Legend({
  yCol,
  legendNames = undefined,
  visible = true,
  colors = undefined,
  isSame = false,
}: legendType) {
  const classes = useStyles();
  if (yCol === undefined) {
    return <div></div>;
  }

  const maxLegend = 6;
  if (legendNames === undefined) {
    let tmp = new Set(
      Array(yCol.allClasses.length)
        .fill(0)
        .map((v, i) => yCol.getClassByIndex(i, true))
    );
    legendNames = yCol.nonSparseClasses;
    if (tmp.has("Other Classes")) {
      legendNames = [...yCol.nonSparseClasses, "Other Classes"];
    }
  }
  const legendOverflow = legendNames.length > maxLegend;
  if (colors === undefined) {
    let outColors = getBarColors(Array(legendNames.length).fill(""));
    if (isSame) {
      outColors = getBarColorsSame(Array(legendNames.length).fill(""));
    }
    colors = outColors.colors.map((val, i) =>
      addAlpha(val, outColors.alphas[i])
    );
  }

  if (legendOverflow) {
    legendNames = [
      ...legendNames.slice(0, 3),
      ...legendNames.slice(legendNames.length - 3, legendNames.length),
    ];
    colors = [
      ...colors.slice(0, 3),
      ...colors.slice(colors.length - 3, colors.length),
    ];
  }

  return (
    <div className={classes.legendContainer}>
      {colors.map((c, i) => (
        <div style={{ display: "flex", flexDirection: "row" }}>
          {legendOverflow && i == 3 ? (
            <div className={classes.ellipse}>. . .</div>
          ) : (
            <div></div>
          )}
          <LegendItem color={colors[i]} name={legendNames[i]}></LegendItem>
        </div>
      ))}
    </div>
  );
}
